import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import config from '@epi-config';
import { IMassUploadDetails } from '@epi-models/pages/MassUploadDetails';
import {
  IMassUploadHistoryResponse,
  MassUploadStatus
} from '@epi-models/pages/MassUpload';

const baseUrl = `${config.apiHost}/api/mass-upload-history`;

export const getMassUploadHistoryRequest = async (
  page: number,
  pageSize: number,
  status: MassUploadStatus | undefined,
  signal: AbortSignal
): Promise<{ data?: IMassUploadHistoryResponse; error?: any }> => {
  try {
    const statusQuery = status ? `&status=${encodeURIComponent(status)}` : '';
    const url = `${baseUrl}/${page}?pageSize=${pageSize}${statusQuery}`;
    const response: IMassUploadHistoryResponse | undefined = await get(
      url,
      undefined,
      undefined,
      signal
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

export const getMassUploadDetailsRequest = async (
  uploadId: number,
  page: number,
  pageSize: number,
  signal: AbortSignal
): Promise<{ data?: IMassUploadDetails; error?: any }> => {
  try {
    const url = `${baseUrl}/${uploadId}/details/${page}?pageSize=${pageSize}`;
    const response: IMassUploadDetails | undefined = await get(
      url,
      undefined,
      undefined,
      signal
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

export const massUploadHistoryApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getMassUploadHistory: build.query<
      IMassUploadHistoryResponse,
      { page: number; pageSize?: number; status?: MassUploadStatus }
    >({
      queryFn: async ({ page, pageSize = 10, status }, { signal }) =>
        getMassUploadHistoryRequest(page, pageSize, status, signal),
      keepUnusedDataFor: 0
    }),
    getMassUploadDetails: build.query<
      IMassUploadDetails,
      { uploadId: number; page: number; pageSize?: number }
    >({
      queryFn: async ({ uploadId, page, pageSize = 10 }, { signal }) =>
        getMassUploadDetailsRequest(uploadId, page, pageSize, signal),
      keepUnusedDataFor: 0
    })
  })
});

export const {
  useGetMassUploadHistoryQuery,
  useGetMassUploadDetailsQuery,
  useLazyGetMassUploadDetailsQuery
} = massUploadHistoryApi;
